import { useState, useCallback, useEffect, useRef } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL1 = process.env.REACT_APP_LIVE_URL;

// const useTrades = () => {
//   const [trades, setTrades] = useState([]);
//   const [profitableTrades, setProfitableTrades] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchAllTrades = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const { data } = await axios.get(`${BASE_URL}/api/trades/history`);

//       if (data?.success) {
//         setTrades(data.trades || []);
//       }
//     } catch (err) {
//       setError(err?.response?.data?.message || err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   const fetchProfitableTrades = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const { data } = await axios.get(`${BASE_URL}/api/trades/profitable`);

//       if (data?.success) {
//         setProfitableTrades(data.trades || []);
//         setStats(data.stats || null);
//       }
//     } catch (err) {
//       setError(err?.response?.data?.message || err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   return {
//     trades,
//     profitableTrades,
//     stats,
//     loading,
//     error,
//     fetchAllTrades,
//     fetchProfitableTrades,
//   };
// };

const useTrades = () => {
  const [trades, setTrades] = useState([]);
  const [profitableTrades, setProfitableTrades] = useState([]);
  const [openTrades, setOpenTrades] = useState([]);
  const [allClosedTrades, setAllClosedTrades] = useState([]); // ← NEW
  const [allStats, setAllStats] = useState(null);
  const [livePrices, setLivePrices] = useState({});
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [losingTrades, setLosingTrades] = useState([]);
  const [lossStats, setLossStats] = useState(null);

  const sseRef = useRef(null);
  const userIdRef = useRef(null);

  const fetchLosingTrades = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api/losing`);
      const json = await res.json();
      if (json.success) {
        setLosingTrades(json.trades);
        setLossStats(json.stats);
        return json.trades;
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // return: { ..., losingTrades, lossStats, fetchLosingTrades }

  const fetchAllTrades = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await axios.get(`${BASE_URL}/api/trades/history`);
      if (data?.success) setTrades(data.trades || []);
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  }, []);
  // const fetchAllClosedTrades = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     setError(null);
  //     const { data } = await axios.get(`${BASE_URL}/api/trades/all-closed`);
  //     if (data?.success) {
  //       const allTrades = data.trades || [];
  //       setProfitableTrades(allTrades);

  //       const winners = allTrades.filter((t) => t.pnl_amount > 0);
  //       const losers = allTrades.filter((t) => t.pnl_amount <= 0);
  //       const totalProfit = winners.reduce(
  //         (s, t) => s + Number(t.pnl_amount),
  //         0,
  //       );
  //       const totalLoss = losers.reduce((s, t) => s + Number(t.pnl_amount), 0);

  //       setStats({
  //         totalTrades: allTrades.length,
  //         winners: winners.length,
  //         losers: losers.length,
  //         winRate: allTrades.length
  //           ? Math.round((winners.length / allTrades.length) * 100)
  //           : 0,
  //         totalProfit: Number(totalProfit.toFixed(2)),
  //         totalLoss: Number(totalLoss.toFixed(2)),
  //         netPnl: Number((totalProfit + totalLoss).toFixed(2)),
  //         avgPoints: allTrades.length
  //           ? Number(
  //               (
  //                 allTrades.reduce((s, t) => s + Number(t.pnl_points || 0), 0) /
  //                 allTrades.length
  //               ).toFixed(1),
  //             )
  //           : 0,
  //         bestTrade: winners.length
  //           ? winners.reduce((best, t) =>
  //               Number(t.pnl_amount) > Number(best.pnl_amount) ? t : best,
  //             )
  //           : null,
  //         worstTrade: losers.length
  //           ? losers.reduce((worst, t) =>
  //               Number(t.pnl_amount) < Number(worst.pnl_amount) ? t : worst,
  //             )
  //           : null,
  //         byReason: allTrades.reduce((acc, t) => {
  //           const r = t.exit_reason || "UNKNOWN";
  //           if (!acc[r]) acc[r] = { count: 0, total: 0 };
  //           acc[r].count++;
  //           acc[r].total += Number(t.pnl_amount || 0);
  //           return acc;
  //         }, {}),
  //         topSymbols: Object.values(
  //           allTrades.reduce((acc, t) => {
  //             if (!acc[t.symbol])
  //               acc[t.symbol] = { symbol: t.symbol, total: 0, count: 0 };
  //             acc[t.symbol].total += Number(t.pnl_amount || 0);
  //             acc[t.symbol].count++;
  //             return acc;
  //           }, {}),
  //         )
  //           .sort((a, b) => b.total - a.total)
  //           .slice(0, 10),
  //       });
  //       return allTrades;
  //     }
  //   } catch (err) {
  //     setError(err?.response?.data?.message || err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);
  const fetchAllClosedTrades = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await axios.get(`${BASE_URL}/api/trades/all-closed`);
      if (data?.success) {
        const allTrades = data.trades || [];
        setAllClosedTrades(allTrades); // ← changed

        const winners = allTrades.filter((t) => t.pnl_amount > 0);
        const losers = allTrades.filter((t) => t.pnl_amount <= 0);
        const totalProfit = winners.reduce(
          (s, t) => s + Number(t.pnl_amount),
          0,
        );
        const totalLoss = losers.reduce((s, t) => s + Number(t.pnl_amount), 0);

        setAllStats({
          // ← changed
          totalTrades: allTrades.length,
          winners: winners.length,
          losers: losers.length,
          winRate: allTrades.length
            ? Math.round((winners.length / allTrades.length) * 100)
            : 0,
          totalProfit: Number(totalProfit.toFixed(2)),
          totalLoss: Number(totalLoss.toFixed(2)),
          netPnl: Number((totalProfit + totalLoss).toFixed(2)),
          avgPoints: allTrades.length
            ? Number(
                (
                  allTrades.reduce((s, t) => s + Number(t.pnl_points || 0), 0) /
                  allTrades.length
                ).toFixed(1),
              )
            : 0,
          bestTrade: winners.length
            ? winners.reduce((b, t) =>
                Number(t.pnl_amount) > Number(b.pnl_amount) ? t : b,
              )
            : null,
          worstTrade: losers.length
            ? losers.reduce((w, t) =>
                Number(t.pnl_amount) < Number(w.pnl_amount) ? t : w,
              )
            : null,
          byReason: allTrades.reduce((acc, t) => {
            const r = t.exit_reason || "UNKNOWN";
            if (!acc[r]) acc[r] = { count: 0, total: 0 };
            acc[r].count++;
            acc[r].total += Number(t.pnl_amount || 0);
            return acc;
          }, {}),
          topSymbols: Object.values(
            allTrades.reduce((acc, t) => {
              if (!acc[t.symbol])
                acc[t.symbol] = { symbol: t.symbol, total: 0, count: 0 };
              acc[t.symbol].total += Number(t.pnl_amount || 0);
              acc[t.symbol].count++;
              return acc;
            }, {}),
          )
            .sort((a, b) => b.total - a.total)
            .slice(0, 10),
        });
        return allTrades;
      }
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchProfitableTrades = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await axios.get(`${BASE_URL}/api/trades/profitable`);
      if (data?.success) {
        setProfitableTrades(data.trades || []);
        setStats(data.stats || null);
      }
      return trades;
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch open trades
  const fetchOpenTrades = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BASE_URL}/api/trades/open`);
      if (data?.success) {
        setOpenTrades(data.trades || []);
        return data.trades || [];
      }
    } catch (err) {
      console.error("Failed to fetch open trades:", err.message);
    }
    return [];
  }, []);

  // Connect SSE for live prices of open trades
  const connectLivePrices = useCallback((symbols) => {
    if (!symbols.length) return;

    // Close existing connection
    if (sseRef.current) {
      sseRef.current.close();
      sseRef.current = null;
    }

    const sse = new EventSource(`${BASE_URL1}/api/live/feed`);
    sseRef.current = sse;

    sse.addEventListener("connected", async (e) => {
      const { userId } = JSON.parse(e.data);
      userIdRef.current = userId;

      // Subscribe to open trade symbols
      await axios.post(`${BASE_URL1}/api/live/symbols`, {
        userId,
        symbols,
      });
    });

    sse.addEventListener("snapshot", (e) => {
      const snapshot = JSON.parse(e.data);
      setLivePrices((prev) => ({ ...prev, ...snapshot }));
    });

    sse.addEventListener("tick", (e) => {
      const tick = JSON.parse(e.data);
      if (tick.symbol) {
        setLivePrices((prev) => ({ ...prev, [tick.symbol]: tick }));
      }
    });

    sse.onerror = () => {
      console.warn("[SSE] Connection error, retrying...");
    };
  }, []);

  // Auto-refresh open trades every 30 seconds
  useEffect(() => {
    const interval = setInterval(async () => {
      const trades = await fetchOpenTrades();
      if (trades.length) {
        const symbols = trades.map((t) => t.symbol);
        if (userIdRef.current) {
          await axios.post(`${BASE_URL1}/api/live/symbols`, {
            userId: userIdRef.current,
            symbols,
          });
        }
      }
    }, 30000);

    return () => {
      clearInterval(interval);
      if (sseRef.current) {
        sseRef.current.close();
        sseRef.current = null;
      }
    };
  }, [fetchOpenTrades]);

  // return {
  //   trades,
  //   profitableTrades,
  //   openTrades,
  //   livePrices,
  //   stats,
  //   loading,
  //   error,
  //   fetchAllTrades,
  //   fetchProfitableTrades,
  //   fetchOpenTrades,
  //   connectLivePrices,
  // };

  // return {
  //   trades,
  //   profitableTrades,
  //   openTrades,
  //   livePrices,
  //   stats,
  //   loading,
  //   error,
  //   fetchAllTrades,
  //   fetchProfitableTrades,
  //   fetchAllClosedTrades, // ← add this
  //   fetchOpenTrades,
  //   connectLivePrices,
  // };

  return {
    trades,
    profitableTrades, // winners only (existing)
    allClosedTrades, // ← NEW: wins + losses
    openTrades,
    livePrices,
    stats, // stats for profitable
    allStats, // ← NEW: stats for all closed
    loading,
    error,
    fetchAllTrades,
    fetchProfitableTrades,
    fetchAllClosedTrades,
    fetchOpenTrades,
    connectLivePrices,
    fetchLosingTrades,
    losingTrades,
    lossStats,
  };
};

export default useTrades;
